import React from 'react';
import { loadStripe } from "@stripe/stripe-js";
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { getInvoiceItems } from "../services/PaymentService";
import "../styles/PurchaseHistory.css";

const PurchaseHistory = () => {
    const { stripeCustomerId: stripeCustomerId = ''} = useSelector((state) => state.userDetails);
    const [invoices, setInvoices] = useState([]);
    const [sortOrder, setSortOrder] = useState("desc");


    useEffect(() => {
        loadPurchaseHistory();
    }
    , []);

    const loadPurchaseHistory = async () => {
        const result = await getInvoiceItems(stripeCustomerId);
        if (result.success) {
            const sorted = [...result.invoiceItems].sort((a, b) =>
                sortOrder === "asc" ? a.created - b.created : b.created - a.created
            );
            setInvoices(sorted);
        } else {
            console.error(result.error);
        }
    };

    const toggleSortOrder = () => {
        const newOrder = sortOrder === "asc" ? "desc" : "asc";
        setSortOrder(newOrder);
        setInvoices((prev) =>
            [...prev].sort((a, b) =>
                newOrder === "asc" ? a.created - b.created : b.created - a.created
            )
        );
    };
    
    

    const handleDownload = async (receipt_url) => {
        // split off any query string
        const [base, query] = receipt_url.split('?');
        // re-build with "/pdf" inserted
        const pdfUrl = `${base}/pdf${query ? '?' + query : ''}`;
      
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'receipt.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      

    return (
        <div>
            <h1>Purchase History</h1>
            <div className='tab-content'>
                <table className='test-summary-table'>
                    <thead className='test-summary-table-headers'>
                        <tr style={{ background: "none" }}>
                            <th>Receipt Number</th>
                            <th style={{ cursor: "pointer" }} onClick={toggleSortOrder}>
                                Date {sortOrder === "asc" ? "↑" : "↓"}
                            </th>
                            <th>Amount Paid</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices && invoices?.map((row, index) => (
                            <tr key={index} className='test-summary-table-row'>
                                <td>{row.receipt_number}</td>
                                <td>
                                    {new Date(Number(row.created) * 1000).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    })}
                                </td>
                                <td>${row.amount/100}</td>
                                <td className='status-container'>
                                    <span className='paid'>{row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase()}</span>
                                </td>
                                <td className='download-invoice-container'>
                                    <div
                                        className='download-invoice'
                                        onClick={() => handleDownload(row.receipt_url)}>
                                        Download
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PurchaseHistory;